<template>
  <div class="self_adaption">
    <div class="self_adaption_main">
      <el-form ref="form" :model="form" label-width="96px" label-position="right" class="FormFlex"
        style="justify-content: space-between;">
        <div class="FormBtn" style="width:100%;display:flex;justify-content:flex-end;">
          <el-button size="medium" type="success" @click="addData()">上传图片</el-button>
        </div>
      </el-form>
      <el-table :data="formList" border style="width: 100%;" :header-cell-style="{ background: 'rgb(238,249,253)' }">
        <el-table-column type="index" align="center" width="60" label="序号"></el-table-column>
        <el-table-column prop="title" align="center" label="发布会主题"></el-table-column>
        <el-table-column prop="name" align="center" label="图片名称"></el-table-column>
        <el-table-column prop="title" align="center" label="图片预览">
          <template #default="{ row }">
            <el-image class="imgsize" :preview-src-list="imageList" :src="row.urlpath"></el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="220">
          <template slot-scope="scoped">
            <el-tag style="margin:0px 5px" @click="Details('edit', scoped.row)" size="small" class="cursor">编辑</el-tag>
            <el-tag style="margin:0px 5px" @click="Details('del', scoped.row)" size="small" class="cursor">删除</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="text-align:right;margin:20px 0px;">
        <!-- 分页 -->
        <pagination v-show="(Number(total) > 0)" :total="Number(total)" :page.sync="form.current"
          :limit.sync="form.size" @pagination="renderData" />
      </div>
    </div>
    <!-- 新增图片 -->
    <el-dialog title="文件上传" :visible.sync="dialogVisible" width="30%">
      <el-form :rules="rules" ref="formimgList" :model="formimgList" label-width="90px">
        <el-form-item label="图片名称:" prop="name">
          <el-input  v-model="formimgList.name" placeholder="请输入图片名称"></el-input>
        </el-form-item>
        <!-- 导入 -->
        <el-form-item label="图片:">
          <!-- 导入 -->
          <el-upload name="fileAtt" :action="uploadUrl" :beforeUpload="beforeuploadfile" ref="uploadfile"
            :headers="uploadHeaders" :data="uploadData" :limit="1" :file-list="imgFilesList"
            :on-success="(response, file) => uploadSuccess(response, file, fileList)">
            <el-button type="primary" plain size="mini" @click="chooseImgClick">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitfile">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  surveyquestionsImgList,
  surveyquestionsImgSave,
  surveyquestionsImgDel,
  getMsgByIdApi,
  downLoadApi,
  uploadUrl
} from '@/api/axiosUrl';
import tools from '@/api/tools'
import pagination from '@/components/pagination'
export default {
  name: 'Img',
  components: {
    pagination
  },
  props: { dataId: String },
  data () {
    return {
      form: {
        current: 1,
        size: 10,
        surveyId: this.dataId

      },
      imgFilesList: [],
      uploadUrl: '',
      uploadHeaders: {
        Authorization: ''
      },
      uploadData: {
        paramName: 'fileAtt',
        permission: 'domain',
        modelId: process.env.VUE_APP_MODEL_ID
      },
      dialogVisible: false,
      total: 0,
      formList: [],
      formimgList: {
        surveyId: this.dataId,
        imgId: '',
        name: ''
      },
      imageList: [],
      fileList: [],
      rules: {
        name: [
          { required: true, message: '请输入图片名称', trigger: 'blur' }
        ]
      }
    };

  },
  created () {
    this.renderData();
    this.uploadUrl = uploadUrl()
  },
  methods: {
    submitfile () {
      this.$refs.formimgList.validate(valid=>{
        if(valid){
          surveyquestionsImgSave(this.formimgList).then((res) => {
            if (res.status === 200) {
              this.$message({
                message: '上传成功',
                type: 'success'
              });
            } else {
              this.$message({
                message: '上传失败,请重新上传',
                type: 'error'
              });
            }
            this.renderData()
            this.dialogVisible = false
          })
        }
      })
    },
    beforeuploadfile () {
      this.$set(this.uploadHeaders, 'Authorization', tools.authorization())
    },
    chooseImgClick() {
      this.imgFilesList = []
    },
    uploadSuccess (response) {
      if (response.status === 200) {
        console.log(response.data.id)
        this.formimgList.imgId = response.data.id
      } else {
        this.$message({
          message: '上传失败,请重新上传',
          type: 'error'
        });
      }
    },
    addData () {
      this.formimgList.imgId = ''
      this.formimgList.name = ''
      this.imgFilesList = []
      this.dialogVisible = true
    },
    //进入页面去渲染数据
    renderData () {
      this.imageList = []

      surveyquestionsImgList(this.form).then(res => {
        res.data.records.forEach((item) => {
          downLoadApi({ id: item.imgId }).then((res) => {
            this.$set(item, 'urlpath', URL.createObjectURL(new Blob([res], { type: 'image/jpeg' })))
            this.imageList.push(item.urlpath)
          })
        })
        this.formList = res.data.records;
        this.total = Number(res.data.total);
      });
    },
    Details (flag, data) {
      var _this = this
      if (flag == 'edit') {
        this.formimgList = data
        this.imgFilesList = []
        getMsgByIdApi({ id: data.imgId }).then((res) => {
          this.imgFilesList.push({
            "url": res.data.path,
            "name": res.data.name,
            "id": res.data.id
          })
        })

        this.dialogVisible = true
      } else if (flag == 'del') {
        _this.$confirm('此操作将永久删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          surveyquestionsImgDel({ id: data.id }).then(res => {
            if (res.status == 200) {
              _this.$message.success('删除成功')
              _this.renderData()
            } else {
              _this.$message.error('删除失败')
            }
          });
        })
      }
    },
    handleCurrentChange () {
      this.renderData()
    },
  }
}
</script>

<style scoped>
.imgsize {
  max-height: 50px;
  max-width: 50px;
}
</style>
